import React, { useState } from "react";
import { HiChevronDown } from "react-icons/hi2";
import "./FAQ.scss";

const FAQ = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        {
            question: "¿Qué es Atlyon?",
            answer: "Atlyon es una plataforma que conecta a empresas y profesionales con proveedores verificados de captura y modelado 3D. Nuestro objetivo es simplificar el proceso de búsqueda y conexión, garantizando calidad, cercanía y eficiencia en cada proyecto.",
        },
        {
            question: "¿Cómo funciona el proceso?",
            answer: "Solo tienes que describir tu proyecto indicando el tipo de servicio, ubicación y requisitos técnicos. Atlyon analiza tus necesidades y te pone en contacto con los proveedores que mejor se adaptan a tu perfil. Desde ahí, puedes comunicarte directamente con ellos para acordar los detalles y avanzar con tu proyecto.",
        },
        {
            question:
                "¿Atlyon realiza los escaneos o solo conecta con proveedores?",
            answer: "Atlyon no realiza directamente los escaneos ni modelos 3D. Somos un punto de conexión: una red que une a quienes necesitan servicios de captura con los profesionales que los ofrecen.",
        },
        {
            question: "¿Los proveedores están verificados?",
            answer: "Sí. Todos los proveedores que forman parte de Atlyon son evaluados cuidadosamente según su experiencia, equipamiento, reputación y calidad técnica. Solo los perfiles que cumplen nuestros estándares entran en la red.",
        },
        {
            question: "¿Tiene algún coste usar Atlyon?",
            answer: "Registrar tu proyecto en Atlyon y recibir propuestas es completamente gratuito. Solo pagarás directamente al proveedor una vez acordados los servicios y condiciones.",
        },
        {
            question: "¿En qué zonas está disponible?",
            answer: "Atlyon trabaja con una red de proveedores distribuidos en todo el territorio nacional, por lo que siempre encontrarás un especialista cercano o dispuesto a desplazarse según tus necesidades.",
        },
        {
            question: "¿Qué tipo de proyectos puedo publicar?",
            answer: "Puedes publicar proyectos relacionados con captura 3D, escaneado láser, fotogrametría, modelado 3D, documentación arquitectónica, ingeniería, patrimonio, construcción y más.",
        },
        {
            question: "¿Cómo protege Atlyon mi información?",
            answer: "La seguridad de tus datos es una prioridad. Atlyon cumple con la normativa vigente en materia de protección de datos y garantiza que tu información solo será utilizada para facilitar la conexión con proveedores y mejorar tu experiencia en la plataforma.",
        },
    ];

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section id="faq" className="faq">
            <div className="faq__container">
                <div className="faq__header">
                    <h2 className="faq__title">Preguntas frecuentes</h2>
                    <p className="faq__subtitle">
                        Encuentra respuestas rápidas a las preguntas más comunes
                        sobre Atlyon y nuestros servicios.
                    </p>
                </div>

                <div className="faq__list">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`faq-item ${
                                openIndex === index ? "faq-item--open" : ""
                            }`}
                        >
                            <button
                                className="faq-item__question"
                                onClick={() => toggleAccordion(index)}
                            >
                                <span className="question-text">
                                    {faq.question}
                                </span>
                                <HiChevronDown className="question-icon" />
                            </button>
                            <div className="faq-item__answer">
                                <p>{faq.answer}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQ;
